<div class="container-fluid">
  <app-page-header
    title="Dashboard"
    icon="fas fa-chart-line"
    subtitle="Visão geral do atendimento">
  </app-page-header>

  <!-- @if (error || erro403) {
    @if (erro403) {
      <app-no-access></app-no-access>
    } @else {
      <div class="col-12">
        <div class="alert alert-danger" role="alert">{{ error }}</div>
      </div>
    }
  }  -->
  
  <!-- @else { -->

    @if (isLoading) {
      <div class="text-center py-5">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Carregando...</span>
        </div>
        <p class="mt-2 text-muted">Carregando métricas do dashboard...</p>
      </div>
    } @else {
      <div class="row">
        <!-- Atendentes Online -->
        <div class="col-xl-4 col-md-6 mb-3">
          <div class="card status-card">
            <div class="card-body">
              <div class="d-flex align-items-center">
                <div class="flex-shrink-0">
                  <div class="avatar-sm">
                    <span class="avatar-title bg-primary-subtle text-primary rounded-circle fs-2">
                      <i class="fas fa-users"></i>
                    </span>
                  </div>
                </div>
                <div class="flex-grow-1 ms-3">
                  <h6 class="text-muted mb-2 font-size-12 text-uppercase">Atendentes Online</h6>
                  <h4 class="mb-0 text-primary">
                    {{ metrics?.atendentesOnline || 0 }}/{{ metrics?.totalAtendentes || 0 }}
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Conversas Abertas -->
        <div class="col-xl-4 col-md-6 mb-3">
          <div class="card status-card">
            <div class="card-body">
              <div class="d-flex align-items-center">
                <div class="flex-shrink-0">
                  <div class="avatar-sm">
                    <span class="avatar-title bg-success-subtle text-success rounded-circle fs-2">
                      <i class="fas fa-comments"></i>
                    </span>
                  </div>
                </div>
                <div class="flex-grow-1 ms-3">
                  <h6 class="text-muted mb-2 font-size-12 text-uppercase">Conversas Abertas</h6>
                  <h4 class="mb-0 text-success">
                    {{ metrics?.conversasAbertas || 0 }}
                    @if (metrics?.conversasAbertasVariacao) {
                      <span class="text-success font-size-12 ms-1">
                        <i class="fas fa-arrow-up"></i> {{ metrics?.conversasAbertasVariacao }}%
                      </span>
                    }
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Aguardando Atendimento -->
        <div class="col-xl-4 col-md-6 mb-3">
          <div class="card status-card">
            <div class="card-body">
              <div class="d-flex align-items-center">
                <div class="flex-shrink-0">
                  <div class="avatar-sm">
                    <span class="avatar-title bg-warning-subtle text-warning rounded-circle fs-2">
                      <i class="fas fa-clock"></i>
                    </span>
                  </div>
                </div>
                <div class="flex-grow-1 ms-3">
                  <h6 class="text-muted mb-2 font-size-12 text-uppercase">Aguardando Atendimento</h6>
                  <h4 class="mb-0 text-warning">{{ metrics?.aguardandoAtendimento || 0 }}</h4>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Tempo Médio de Resposta -->
        <!-- <div class="col-xl-3 col-md-6 mb-3">
          <div class="card status-card">
            <div class="card-body">
              <div class="d-flex align-items-center">
                <div class="flex-shrink-0">
                  <div class="avatar-sm">
                    <span class="avatar-title bg-info-subtle text-info rounded-circle fs-2">
                      <i class="fas fa-bolt"></i>
                    </span>
                  </div>
                </div>
                <div class="flex-grow-1 ms-3">
                  <h6 class="text-muted mb-2 font-size-12 text-uppercase">Tempo Médio de Resposta</h6>
                  <h4 class="mb-0 text-info">
                    {{ metrics?.tempoMedioResposta || '0min' }}
                    @if (metrics?.tempoMedioRespostaVariacao) {
                      <span class="text-success font-size-12 ms-1">
                        <i class="fas fa-arrow-up"></i> {{ metrics?.tempoMedioRespostaVariacao }}%
                      </span>
                    }
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div> -->
      </div>
    }
  <!-- } -->
</div>
